import { ServiceNowFeatureContext } from './service-now.config';
import { ServiceNowFeature } from './service-now.constants';

export const featureContexts: ServiceNowFeatureContext[] = [
  {
    feature: ServiceNowFeature.DNV_CERTIFICATE,
    static: {},
    params: {
      id: 'id',
      sys_id: 'sys_id',
      language: 'language',
      reportingCountry: 'sysparm_reportingCountry',
      projectNumber: 'projectNumber',
      certificateNumber: 'certificateNumber',
      revisionNumber: 'revisionNumber',
      certificateID: 'certificateID',
      certificateStatus: 'certificateStatus',
      service: 'service',
      accountDNVId: 'accountDNVId',
      communicationLanguageCode: 'sysparm_communicationLanguageCode',
      reportingUnit: 'reportingUnit',
      OSCContactID: 'OSCContactID',
    },
  },
  {
    feature: ServiceNowFeature.DNV_INVOICE,
    static: {},
    params: {
      id: 'id',
      sys_id: 'sys_id',
      language: 'language',
      reportingCountry: 'sysparm_reportingCountry',
      projectNumber: 'projectNumber',
      invoice: 'invoice',
      status: 'status',
      accountDNVId: 'accountDNVId',
      communicationLanguageCode: 'sysparm_communicationLanguageCode',
      reportingUnit: 'reportingUnit',
      OSCContactID: 'OSCContactID',
    },
  },
  {
    feature: ServiceNowFeature.DNV_SCHEDULE,
    static: {},
    params: {
      id: 'id',
      sys_id: 'sys_id',
      language: 'language',
      reportingCountry: 'sysparm_reportingCountry',
      projectNumber: 'projectNumber',
      startDate: 'startDate',
      endDate: 'endDate',
      auditID: 'auditID',
      siteAuditID: 'siteAuditID',
      siteAddress: 'siteAddress',
      site: 'site',
      status: 'status',
      service: 'service',
      siteCity: 'siteCity',
      siteZip: 'siteZip',
      siteCountry: 'siteCountry',
      siteState: 'siteState',
      accountDNVId: 'accountDNVId',
      communicationLanguageCode: 'sysparm_communicationLanguageCode',
      reportingUnit: 'reportingUnit',
      OSCContactID: 'OSCContactID',
    },
  },
  {
    feature: ServiceNowFeature.DNV_COMPANY,
    static: {},
    params: {
      id: 'id',
      sys_id: 'sys_id',
      language: 'language',
      reportingCountry: 'sysparm_reportingCountry',
      accountDNVId: 'accountDNVId',
      account_id: 'account_id',
      accountName: 'organizationName',
      accountAddress: 'accountAddress',
      communicationLanguageCode: 'sysparm_communicationLanguageCode',
      OSCContactID: 'OSCContactID',
    },
  },
  {
    feature: ServiceNowFeature.HOME,
    static: {},
    params: {
      language: 'language',
      reportingCountry: 'sysparm_reportingCountry',
      communicationLanguageCode: 'sysparm_communicationLanguageCode',
      OSCContactID: 'OSCContactID',
    },
  },
  {
    feature: ServiceNowFeature.CATALOG_ITEM,
    static: {},
    params: {
      id: 'id',
      sys_id: 'sys_id',
      language: 'language',
      table: 'table',
    },
  },
  {
    feature: ServiceNowFeature.DNV_SITES,
    static: {},
    params: {
      id: 'id',
      sys_id: 'sys_id',
      language: 'language',
      reportingCountry: 'sysparm_reportingCountry',
      accountDNVId: 'accountDNVId',
      OSCContactID: 'OSCContactID',
      OSvCSiteID: 'OSvCSiteID',
      communicationLanguageCode: 'sysparm_communicationLanguageCode',
      siteName: 'siteName',
      siteNickname: 'siteNickname',
      siteAddress: 'siteAddress',
    },
  },
];
